import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddSalesRegister from "../forms/AddSalesRegister/AddSalesRegister";
import UploadFile from "../forms/UploadFile/UploadFile";
import SalesUploadedFiles from "../forms/UploadedSalesFiles/UploadedSalesFiles";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { salesListing } from "../../../Bookclosure/Services/ApiHandler";
import { GetSale } from "../../../WorkSpace/Components/ApiServices/apiHandler";

import styles from "./SalesregHeader.module.css";

const SalesregHeader = ({
  saleID,
  setSaleID,
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showSalesUploadedFiles, setShowSalesUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return !isNaN(date.getTime()) ? date.toISOString().split("T")[0] : "";
  };

  const resolveAsOnDateFromItems = (items, id) => {
    if (!Array.isArray(items)) return "";
    const match = items.find(
      (item) =>
        item &&
        (item._id === id ||
          item.id === id ||
          item.saleID === id ||
          item.purchaseID === id ||
          item.fixedAssetID === id)
    );
    if (match?.createdAt) {
      return formatDateInputValue(match.createdAt);
    }
    const firstCreatedAt = items.find((item) => item?.createdAt)?.createdAt;
    return formatDateInputValue(firstCreatedAt);
  };

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await salesListing(saleID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
        if (response.data?.saleListing?.length > 0) {
          setShowTable(true);
          setShowDataState(false);
          setTableType("excel");
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    const fetchAsOnDate = async () => {
      if (!saleID) {
        setAsOnDate(new Date().toISOString().split("T")[0]);
        return;
      }

      try {
        const response = await GetSale();
        const sales = response.data?.sales || response.data?.sale || response.data?.result || [];
        const dateFromSales = resolveAsOnDateFromItems(sales, saleID);
        if (dateFromSales) {
          setAsOnDate(dateFromSales);
          return;
        }

        const listingDate = formatDateInputValue(response.data?.saleListing?.[0]?.createdAt);
        setAsOnDate(listingDate || new Date().toISOString().split("T")[0]);
      } catch (error) {
        console.error("Failed to fetch sale createdAt:", error);
        setAsOnDate(new Date().toISOString().split("T")[0]);
      }
    };

    if (saleID) {
      fetchFilterConfig();
      fetchAsOnDate();
    }
  }, [saleID]);

  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => {
      console.log("Removed file:", prev[index]?.name);
      const newFiles = prev.filter((_, i) => i !== index);
      return newFiles;
    });
  };

  const handleAddFiles = () => {
    setShowSalesUploadedFiles(false);
    setShowUploadFileModal(true);
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToSalesUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      return {
        rawFile: file,
        displayName: computedName,
        isMapped: false,
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowSalesUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    setShowSalesUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.map((item, idx) =>
          idx === selectedFileIndex ? { ...item, isMapped: true } : item
        )
      );
    }
    setShowSubMapping(false);
    setShowSalesUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowSalesUploadedFiles(true);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      alert("Please map at least one file before finishing.");
      return;
    }
    setShowSalesUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.salesregheader_container}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            date={asOnDate}
            onChange={(e) => setAsOnDate(e.target.value)}
            label="As on"
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddSalesRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadFile
          SaleID={saleID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceed={handleProceedToSalesUploadedFiles}
        />
      )}

    
      {showSalesUploadedFiles && (
        <SalesUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowSalesUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onClose={() => setShowSalesUploadedFiles(false)}
          onRemove={handleRemoveFile}
          onAdd={handleAddFiles}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          SaleID={saleID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => setShowColumnMapping(false)}
          onCancel={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          SaleID={saleID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onMapped={handleSubmappingSuccess}
          onSubmitMapping={handleSubmitSubMapping}
          onClose={() => setShowSubMapping(false)}
          onCancel={() => {
            setShowSubMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default SalesregHeader;
